"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Undo = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Undo = function Undo() {
  return react_1.default.createElement("path", {
    d: "M22 15.46C22.0112 15.5994 21.9635 15.7371 21.8685 15.8397C21.7735 15.9423 21.6398 16.0004 21.5 16H20C19.7443 16.0008 19.5309 15.8049 19.51 15.55C19.22 12.73 16.2 10.5 12.51 10.5C10.6166 10.4682 8.77476 11.1176 7.32001 12.33L9.84001 14.85C9.93766 14.944 9.99197 15.0744 9.99001 15.21V15.5C9.99001 15.7761 9.76615 16 9.49001 16H2.49001C2.21386 16 1.99001 15.7761 1.99001 15.5V8.49997C1.98998 8.36561 2.04403 8.2369 2.13997 8.14283C2.23591 8.04877 2.36567 7.99728 2.50001 7.99997H2.79001C2.92559 7.998 3.05593 8.05231 3.15001 8.14997L5.57001 10.57C7.50396 8.87499 9.99873 7.95906 12.57 7.99997C17.55 7.99997 21.67 11.29 22 15.46Z",
    fill: "currentColor"
  });
};

exports.Undo = Undo;